// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Toda la altura de la pantalla */
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}


.app-footer {
  background-color: #282c34;
  color: white;
  padding: 20px;
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  display: flex;
  align-items: center;        /* Centra verticalmente */
  justify-content: center;    /* Centra horizontalmente */
  width: 100%;                /* Asegura que ocupe todo el ancho */
  border-top: 2px solid #61dafb;
  box-shadow: 0 -3px 5px rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB,SAAS,yBAAyB;EACrD,uBAAuB,KAAK,2BAA2B;EACvD,WAAW,iBAAiB,oCAAoC;EAChE,6BAA6B;EAC7B,yCAAyC;AAC3C","sourcesContent":[".App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Toda la altura de la pantalla */\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nmain {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n\n.app-footer {\n  background-color: #282c34;\n  color: white;\n  padding: 20px;\n  font-size: 1rem;\n  font-weight: 400;\n  text-align: center;\n  display: flex;\n  align-items: center;        /* Centra verticalmente */\n  justify-content: center;    /* Centra horizontalmente */\n  width: 100%;                /* Asegura que ocupe todo el ancho */\n  border-top: 2px solid #61dafb;\n  box-shadow: 0 -3px 5px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
